import { ComponentProps } from 'react';
import { Button } from '../../../../../design-system/button/button';
import { Stack } from '../../../../../design-system/stack/stack';
import { InvoiceCard } from '../invoice-card';

type ExcludeSenderModalContentProps = {
  invoiceInfo: ComponentProps<typeof InvoiceCard>;
  isLoading: boolean;
  onExcludeSender: () => Promise<void>;
};

export const ExcludeSenderModalContent = ({
  invoiceInfo,
  isLoading,
  onExcludeSender,
}: ExcludeSenderModalContentProps) => {
  return (
    <Stack space={10} align="stretch">
      <Stack space={4} align="stretch">
        <Stack space={4} align="stretch">
          <h1 className="text-xl font-medium leading-6 tracking-tight text-black">Exclude this sender</h1>

          <p className="text-base font-medium leading-6 tracking-tight text-seapoint-gray-text">
            This will remove the invoice from your queue and not automatically pull in invoices from this sender again
            in the future. You can manage the list of excluded senders from your invoice settings.
          </p>
        </Stack>

        <InvoiceCard {...invoiceInfo} />
      </Stack>

      <Button variant="default" isLoading={isLoading} onClick={onExcludeSender}>
        Exclude this sender
      </Button>
    </Stack>
  );
};
